import { filterConfiguration } from 'app/components/filters/filters-panel/filter-configuration';
import { Filter, FilterTypes } from 'app/components/filters/types';
import { endpoint } from 'app/area/filters/constants';
import { FilterCodeHierarchy } from './filter-code-hierarchy';
import { createConditionValue } from './create-condition-value';
import { createFavouriteCondition } from 'app/components/filters/filters-panel/conditions/create-conditions';
import { getConditionForOperator } from '../get-condition';

export const selectMultipleHierarchyConfiguration = {
  [FilterTypes.SelectMultipleHierarchy]: filterConfiguration(
    FilterCodeHierarchy,
    endpoint.filterOptionsFor
  )
};

export const selectMultipleHierarchyWithCategoriesConfiguration = {
  [FilterTypes.SelectMultipleHierarchyWithCategories]: filterConfiguration(
    FilterCodeHierarchy,
    endpoint.filterOptionsFor,
    undefined,
    endpoint.filterCategoryOptionsFor,
    true
  )
};

export const selectMultipleHierarchySequentialWithCategoriesConfiguration = {
  [FilterTypes.SelectMultipleHierarchySequentialWithCategories]: filterConfiguration(
    FilterCodeHierarchy,
    endpoint.filterOptionsFor,
    undefined,
    endpoint.filterCategoryOptionsFor,
    true
  )
};

export const selectMultipleHierarchyConditionMapper = (editingValues: any) => {
  const mapper = (filter: Filter) => {

    let condValIndex = 1;
    const editingValue = editingValues?.[filter.id];
    const value = editingValue?.value;
    const conditionValue = createConditionValue(condValIndex++, filter, value);
    const originalCondition = getConditionForOperator(filter.conditions, filter.advancedField.valueOperator);

    return conditionValue ? [createFavouriteCondition(filter, conditionValue, originalCondition)] : [];
  };

  return {
    [FilterTypes.SelectMultipleHierarchy]: mapper,
    [FilterTypes.SelectMultipleHierarchyWithCategories]: mapper,
    [FilterTypes.SelectMultipleHierarchySequentialWithCategories]: mapper
  };
};
